import React from 'react';

import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

import styles from './FilterButton.module.scss';

export interface FilterButtonProps extends MuiButtonProps {
    /**
     * The content/label of the button
     */
    children: React.ReactNode;
    /**
     * If true, applies active filter styling
     */
    isActive?: boolean;
    /**
     * Size of the start/end icon (e.g., '16px', '1rem')
     */
    iconSize?: string;
}

/**
 * FilterButton component for filter toggle actions
 * Based on MUI Button, implements active filter styling from the design system
 * Supports light and dark themes via CSS variables
 */
export const FilterButton = ({
    children,
    isActive = false,
    disabled = false,
    className = '',
    iconSize,
    style,
    ...props
}: FilterButtonProps) => {
    const buttonClass = [styles.filterButton, isActive ? styles.active : '', className].filter(Boolean).join(' ');

    const buttonStyle = {
        ...style,
        '--filter-button-icon-size': iconSize,
    } as React.CSSProperties;

    return (
        <MuiButton className={buttonClass} disabled={disabled} disableElevation style={buttonStyle} {...props}>
            {children}
        </MuiButton>
    );
};
